import { styled } from 'styled-components'

export const Title = styled.h2`
  margin-bottom: 16px;
  color: ${(p) => p.theme.text};
  font-size: 22px;
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 24px 0 16px;
`

export const ErrorComponent = styled.div`
  margin-top: 8px;
  color: red;
  font-size: 14px;
`

export const Section = styled.div`
  margin-bottom: 16px;
  border: 1px solid ${(p) => p.theme.border};
  border-radius: 4px;
  padding: 16px;
`

export const SectionLabel = styled.div`
  margin-bottom: 8px;
  color: ${(p) => p.theme.text};
  font-size: 16px;
  font-weight: 600;
`
